import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function StudentCityPreferenceValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {

		const value = control.value?.trim().replace(/\s+/g, ' ');

		if (!value) {
			return null;
		}

		if (value.length < 2) {
			return { minLengthCity: true };
		}

		if (value.length > 100) {
			return { maxLengthCity: true };
		}
		const cityRegex = /^[A-Za-z\s,-]+$/;

		if (!cityRegex.test(value)) {
			return { invalidCity: true };
		}

		return null;
	};
}